<template xmlns:th="http://www.w3.org/1999/html">
    <div id="faq" class="row pb-3">
        <div class="col-12">
            <h2 class="mb-1" v-html="faqTitle" />
            <!-- Questions / Réponses -->
            <div class="accordion" itemscope="" itemtype="https://schema.org/FAQPage">
                <div
                    v-for="(attribute, attributeIndex) in faqListOfAttributes"
                    :key="'faqAttribute_'
                        + ((attribute.faqTmsDTO && attribute.faqTmsDTO.action) ? attribute.faqTmsDTO.action : '')
                        + '_'
                        + attributeIndex"
                >
                    <div
                        class="card multi"
                        itemscope=""
                        itemprop="mainEntity"
                        itemtype="https://schema.org/Question"
                    >
                        <div :id="'heading-' + attributeIndex" class="card-header">
                            <button
                                :id="'heading-button-' + attributeIndex"
                                class="collapsed"
                                data-bs-toggle="collapse"
                                :data-bs-target="'#collapse-' + attributeIndex"
                                :aria-controls="'#collapse-' + attributeIndex"
                                aria-expanded="false"
                                :data-oevent-category="attribute.faqTmsDTO.category"
                                :data-oevent-action="attribute.faqTmsDTO.action"
                                :data-oevent-label="attribute.faqTmsDTO.label"
                            >
                                <span class="accordion-card-title">
                                    <span class="h3 accordion-title mb-0" itemprop="name" v-html="attribute.title" />
                                    <span class="accordion-icon" aria-hidden="true" />
                                </span>
                            </button>
                        </div>
                        <div
                            :id="'collapse-' + attributeIndex"
                            class="collapse"
                            :aria-labelledby="'heading-button-' + attributeIndex"
                            role="region"
                            itemscope=""
                            itemprop="acceptedAnswer"
                            itemtype="https://schema.org/Answer"
                        >
                            <div class="accordion-card-body standard" itemprop="text">
                                <span v-html="attribute.text" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShowcaseFaq",
    components: {},
    props: {
        faqTitle: {
            type: String,
            required: true
        },
        faqListOfAttributes: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
</style>
